import { motion } from "framer-motion";
import { ArrowLeft, Bot, CloudCog, CreditCard, Layers, ShieldCheck, TrendingUp } from "lucide-react";

const services = [
  {
    icon: TrendingUp,
    title: "التحول الرقمي المؤسسي",
    badge: "استراتيجي",
    desc: "تقييم الجاهزية، خارطة طريق التحول، كراسات المتطلبات BRD/SRS/RFP، وتقييم واختيار المورّدين — بعقلية مالك منتج يفهم الهدف التجاري قبل الشاشة.",
    span: "md:col-span-2 lg:col-span-8",
    wide: true,
  },
  {
    icon: CloudCog,
    title: "بناء منصات SaaS",
    badge: "تطوير سحابي",
    desc: "منصات كاملة من الفكرة إلى الإطلاق: اشتراكات، لوحات إدارة، وقوالب جاهزة للتوسع.",
    span: "md:col-span-1 lg:col-span-4",
  },
  {
    icon: Bot,
    title: "دمج الذكاء الاصطناعي",
    badge: "AI",
    desc: "مساعدون أذكياء، توليد محتوى وصور وفيديو، تلخيص وتحليل مستندات داخل أنظمتك.",
    span: "md:col-span-1 lg:col-span-4",
  },
  {
    icon: CreditCard,
    title: "بوابات الدفع الإلكتروني",
    badge: "FinTech",
    desc: "ربط بوابات الدفع والفوترة والمحافظ الإلكترونية بمعايير PCI DSS وأمان مؤسسي.",
    span: "md:col-span-1 lg:col-span-4",
  },
  {
    icon: Layers,
    title: "مكتب إدارة المشاريع PMO",
    badge: "إدارة وحوكمة",
    desc: "إدارة المشاريع الاستراتيجية، معايير قبول واضحة، وتسليم منظم بمراحل قابلة للقياس.",
    span: "md:col-span-1 lg:col-span-4",
  },
  {
    icon: ShieldCheck,
    title: "الأمن السيبراني وحماية البيانات PDPL",
    badge: "حماية البيانات",
    desc: "تشفير، صلاحيات، سياسات خصوصية واسترداد، وامتثال كامل لنظام حماية البيانات الشخصية السعودي — لأن ثقة عملائك تُبنى على أمان بياناتهم.",
    span: "md:col-span-3 lg:col-span-12",
    wide: true,
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14"
      >
        <div className="font-mono-tech text-xs sm:text-sm tracking-[0.25em] text-[#D4AF37] mb-4" dir="ltr">— OUR SERVICES</div>
        <h2 className="font-display font-extrabold text-2xl sm:text-3xl lg:text-4xl text-[#F8FAFC]" data-testid="services-title">
          خدماتنا <span className="gold-text">من الاستراتيجية إلى التشغيل</span>
        </h2>
        <p className="mt-4 max-w-2xl font-body text-base sm:text-lg text-[#94A3B8]">
          نحن لا نسلّمك كوداً فقط — نسلّمك منتجاً متكاملاً.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-12 gap-5 md:gap-6">
        {services.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            className={`glass-card rounded-3xl p-7 sm:p-8 group ${s.span}`}
            data-testid={`service-card-${i}`}
          >
            <div className="flex items-start justify-between gap-4">
              <div className="w-12 h-12 rounded-2xl bg-[#D4AF37]/10 border border-[#D4AF37]/25 flex items-center justify-center shrink-0 group-hover:bg-[#D4AF37]/20 transition-colors duration-300">
                <s.icon size={22} className="text-[#E5C158]" />
              </div>
              <span className="num-badge rounded-full px-3 py-1 text-[10px] text-[#E5C158]/90 shrink-0">{s.badge}</span>
            </div>
            <h3 className="mt-6 font-display font-bold text-lg sm:text-xl text-[#F8FAFC]">{s.title}</h3>
            <p className={`mt-3 font-body text-sm sm:text-base leading-relaxed text-[#94A3B8] ${s.wide ? "max-w-2xl" : ""}`}>
              {s.desc}
            </p>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector("#contact");
                if (el && window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.2 });
              }}
              data-testid={`service-cta-${i}`}
              className="mt-5 inline-flex items-center gap-2 text-[#D4AF37] hover:gap-3 transition-all duration-300 font-bold text-sm"
            >
              اطلب الخدمة
              <ArrowLeft size={16} />
            </a>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
